module.exports = __webpack_public_path__ + "media/images/bg/shapes/hexagons-2463fe8ace8f8dceae60e9e5a83d2c9d.svg";